import { render, staticRenderFns } from "./ReviewChildProfileModal.vue?vue&type=template&id=30b9c606&scoped=true&"
import script from "./ReviewChildProfileModal.vue?vue&type=script&lang=js&"
export * from "./ReviewChildProfileModal.vue?vue&type=script&lang=js&"
import style0 from "./ReviewChildProfileModal.vue?vue&type=style&index=0&id=30b9c606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b9c606",
  null
  
)

export default component.exports